import { useState } from 'react';
import {
  AutocompleteController,
  AutocompleteProps,
} from './store/AutocompleteController';
import { useMount } from '@apia/util';
import { AutocompleteContext } from './Context';
import { getVariant } from '@apia/theme';
import { SearchBox } from './SearchBox';
import { KeyHandler } from './Keyhandler';

export type AutocompleteCmpProps = {
  handler?: AutocompleteController;
  getHandler?: (handler: AutocompleteController) => unknown;
  properties?: AutocompleteProps;
};

export const Autocomplete = (props: AutocompleteCmpProps) => {
  const [handler, setHandler] = useState<AutocompleteController>();
  useMount(() => {
    const newHandler =
      props.handler ?? new AutocompleteController(props.properties ?? {});
    props.getHandler?.(newHandler);
    setHandler(newHandler);
  });

  if (!handler) {
    return null;
  }

  return (
    <AutocompleteContext.Provider value={handler}>
      <KeyHandler
        className={`autocomplete ${props.properties?.className || ''}`}
        data-autocomplete-box={handler.state.id}
        {...getVariant('layout.common.components.autocomplete')}
      >
        <SearchBox />
      </KeyHandler>
    </AutocompleteContext.Provider>
  );
};

export * from './store/AutocompleteController';
